<template>
  <div class="px-2 rounded-md min-w-[240px] min-h-[80px]">
    <div
      v-if="isLoadingOrderPosition"
      class="w-full h-full flex items-center justify-center"
    >
      <NLoading />
    </div>

    <div v-else class="grid grid-flow-row grid-cols-2 gap-1 w-full">
      <NText class="self-center" variant="caption2" weight="medium">
        {{ t('modules.order.position') }}
      </NText>

      <div class="text-left">
        <NumberFormatter #="{ number }" :value="orderPositionInfo?.position">
          <NText variant="caption2" weight="medium" dir="ltr">
            {{ number }}
          </NText>
        </NumberFormatter>
      </div>

      <NText class="self-center" variant="caption2" weight="medium">
        {{ t('modules.order.waitingـvolume') }}
      </NText>

      <div class="text-left">
        <NumberFormatter
          #="{ number }"
          :value="orderPositionInfo?.waitingVolume"
          round
        >
          <NText variant="caption2" weight="medium" dir="ltr">
            {{ number }}
          </NText>
        </NumberFormatter>
      </div>

      <NText class="self-center" variant="caption2" weight="medium">
        {{ t('modules.order.waiting_trade_value') }}
      </NText>

      <div class="text-left">
        <NumberFormatter
          #="{ number }"
          :value="orderPositionInfo?.totalWaitingTradeValue"
          round
        >
          <NText variant="caption2" weight="medium" dir="ltr">
            {{ number }}
          </NText>

          <NText
            variant="caption2"
            weight="medium"
            class="text-neutral-secondary ms-1"
          >
            {{ t('misc.rial') }}
          </NText>
        </NumberFormatter>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { NText } from '@negar/core';
import { useGetOrderPosition } from '@core/order';
import { OrderItem } from '@libs/api-reference';

import NumberFormatter from '@/components/Number.vue';

type OrderPositionPropsType = {
  order: OrderItem;
};

const props = defineProps<OrderPositionPropsType>();

const { t } = useI18n();

const { orderPositionInfo, isLoadingOrderPosition } = useGetOrderPosition(
  props.order
);
</script>
